import React, { useEffect, useMemo, FC } from 'react';
import { useSelector } from 'react-redux';

import { useShopConfig } from 'src/explore/hooks/useShopConfig';
import { IStore } from 'src/explore/types/store';
import { getCookie, setCookie } from 'src/prize/services/cookies';

import Modal from './organisms/Modal';

const VIEW_COOKIE = 'first_order_promotion_viewed_at';
const VIEW_COOKIE_EXPIRATION_IN_DAYS = 0.5;

const FirstOrderPromotion: FC = () => {
  const account = useSelector(( state: IStore ) => state.data.account );
  const config = useShopConfig();
  const { discountLabel, modal } = config.firstOrderPromotion;

  const isHidden = useMemo(
    () => getCookie( VIEW_COOKIE ) || !modal.enabled || account.data,
    [ account.data, modal.enabled ]
  );

  useEffect(() => {
    if ( !isHidden ) {
      setCookie(
        'first_order_promotion_viewed_at',
        new Date().getTime(),
        VIEW_COOKIE_EXPIRATION_IN_DAYS
      );
    }
  }, [ isHidden ]);

  if ( isHidden ) return null;

  return (
    <Modal
      discountLabel={discountLabel}
      image={{ desktop: modal.image.desktop, mobile: modal.image.mobile }}
      logo={config.merchantLogo}
      merchant={config.merchantName}
    />
  );
};

export default FirstOrderPromotion;
